(function () {
  function initOffer(root) {
    if (!root || root.dataset.krReady === 'true') return;
    root.dataset.krReady = 'true';

    const sectionId = root.dataset.section;
    let variants = [];
    try {
      variants = JSON.parse(root.querySelector('[data-kr-variants]').textContent);
    } catch (error) {
      variants = [];
    }

    function selectedFlavor() {
      const input = root.querySelector('[data-kr-flavor-input]:checked');
      return input ? input.dataset.flavor : 'natural';
    }

    function updateCards() {
      const flavor = selectedFlavor();
      root.querySelectorAll('[data-kr-pack]').forEach(function (card) {
        const total = card.querySelector('[data-kr-total]');
        const unit = card.querySelector('[data-kr-unit]');
        const badge = card.querySelector('[data-kr-badge]');
        const image = card.querySelector('[data-kr-img]');
        const totalValue = card.dataset[flavor === 'berry' ? 'totalBerry' : 'totalNatural'];
        const unitValue = card.dataset[flavor === 'berry' ? 'unitBerry' : 'unitNatural'];
        const badgeValue = card.dataset[flavor === 'berry' ? 'badgeBerry' : 'badgeNatural'];

        if (total && totalValue) total.textContent = totalValue;
        if (unit && unitValue) unit.textContent = unitValue;
        if (badge) {
          badge.textContent = badgeValue || '';
          badge.hidden = !badgeValue;
        }
        if (image) {
          const nextSrc = flavor === 'berry' ? image.dataset.berry : image.dataset.natural;
          if (nextSrc) image.src = nextSrc;
        }
      });

      const flavorInput = root.querySelector('[data-kr-flavor-input]:checked');
      const flavorLabel = root.querySelector('[data-kr-flavor-label]');
      if (flavorLabel && flavorInput) flavorLabel.textContent = flavorInput.value;

      const qtyInput = root.querySelector('[data-kr-qty] input[type="radio"]:checked');
      const qtyCard = qtyInput ? qtyInput.closest('[data-kr-pack]') : null;
      const qtyName = qtyCard ? qtyCard.querySelector('.kr-card__name') : null;
      const qtyLabel = root.querySelector('[data-kr-qty-label]');
      if (qtyLabel && qtyName) qtyLabel.textContent = qtyName.textContent;

      const gift = root.querySelector('[data-kr-gift]');
      const threePacks = qtyCard && qtyCard.dataset.krPack === '3';
      if (gift && !threePacks) gift.checked = false;
    }

    function updateButton() {
      const button = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!button || button.hasAttribute('disabled')) return;
      const label = button.querySelector('span');
      const idInput = document.querySelector('#product-form-' + sectionId + ' [name="id"]');
      if (!label || !idInput) return;
      const variant = variants.find(function (item) {
        return String(item.id) === String(idInput.value);
      });
      if (!variant || !variant.available) return;
      label.textContent = 'In den Warenkorb • ' + variant.price_label;
    }

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-kr-gift]') && event.target.checked) {
        const threePack = root.querySelector('[data-kr-pack="3"] input[type="radio"]');
        if (threePack && !threePack.checked) {
          threePack.checked = true;
          threePack.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
      }
      updateCards();
      updateButton();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const changedSection = event && event.data && event.data.sectionId;
        if (changedSection && String(changedSection) !== String(sectionId)) return;
        updateButton();
      });
    }

    updateCards();
    updateButton();
  }

  function boot() {
    document.querySelectorAll('[data-kr-offer]').forEach(initOffer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  if (!window.__krGiftSync) {
    window.__krGiftSync = true;

    const giftVariantId = 59791641837893;
    const threePackVariantIds = [59791642296645, 59791642394949];
    const productId = 16274906251589;
    let syncing = false;
    let queued = false;

    function cartRoot() {
      return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    }

    function isThreePack(item) {
      const variantId = Number(item.variant_id || item.id);
      if (threePackVariantIds.indexOf(variantId) !== -1) return true;
      if (Number(item.product_id) !== productId && item.handle !== 'koerper-revolution') return false;
      const values = [];
      if (item.options_with_values) {
        item.options_with_values.forEach(function (option) {
          values.push(option.value);
        });
      }
      if (item.variant_title) values.push(item.variant_title);
      return values.some(function (value) {
        return /3\s*Packung/i.test(String(value || ''));
      });
    }

    function refreshCartDrawer() {
      document.dispatchEvent(
        new CustomEvent('kaching-cart:open', {
          bubbles: true,
          detail: { refetchCart: true, skipDrawerOpen: true },
        })
      );
    }

    async function syncGift() {
      if (syncing) {
        queued = true;
        return;
      }
      syncing = true;
      try {
        do {
          queued = false;
          const cartResponse = await fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' });
          if (!cartResponse.ok) return;
          const cart = await cartResponse.json();
          const items = cart.items || [];
          const gift = items.find(function (item) {
            return Number(item.variant_id || item.id) === giftVariantId;
          });
          if (!gift || items.some(isThreePack)) continue;
          const changeResponse = await fetch(cartRoot() + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: gift.key, quantity: 0 }),
          });
          if (changeResponse.ok) refreshCartDrawer();
        } while (queued);
      } catch (error) {
        queued = false;
      } finally {
        syncing = false;
      }
    }

    document.addEventListener('kaching-cart:cart-updated', function () {
      syncGift();
    });
    document.addEventListener('kaching-cart:item-removed', function () {
      syncGift();
    });
    document.addEventListener(
      'change',
      function (event) {
        const select = event.target;
        if (!select || select.tagName !== 'SELECT') return;
        if (!select.closest('[class*="kaching-cart"]')) return;
        window.setTimeout(syncGift, 800);
      },
      true
    );

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', syncGift);
    } else {
      syncGift();
    }
  }
})();
